import ReactGA from 'react-ga4';

const GA_ID = 'G-5MSB73BVB6';
const isProduction = process.env.NODE_ENV === 'production';

export function initAnalytics() {
  if (!isProduction) return;
  ReactGA.initialize(GA_ID);
}

export function trackPageView(path) {
  if (!isProduction) return;
  ReactGA.send({ hitType: 'pageview', page: path });
}

export function trackEvent(eventName, params = {}) {
  if (!isProduction) return;
  ReactGA.event(eventName, params);
}
